import apiService from './apiService';


export const getNotificationsService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/user-notifications?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};


export const getNotificationUsersService = async (notificationId, params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/user-notifications/${notificationId}/users?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getShareLink = async (payload) => {
  const url = `/admin/share-link`;

  const response = await apiService.post(url, payload);
  return response.data;
};

export const getAdminNotificationsListService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/notifications?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const markAdminNotificationsAsReadService = async (adminUserId) => {
  const url = `/admin/notifications/mark-all-read/${adminUserId}`;
  const response = await apiService.patch(url, null);
  return response.data;
}

export const markAdminNotificationItemAsReadService = async (adminNotificationId) => {
  const url = `/admin/notifications/${adminNotificationId}`;
  const response = await apiService.patch(url, null);
  return response.data;
}

export const getAdminNotificationsBadgeService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/notifications-badge?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getSubscriptionPlansService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/subscription-plans?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const createSubscriptionPlanService = async (payload) => {
  const url = `/admin/subscription-plans`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const patchSubscriptionPlanService = async (subscriptionPlanId, updatedData) => {
  const url = `/admin/subscription-plans/${subscriptionPlanId}`;
  const response = await apiService.patch(url, updatedData);
  return response.data;
}

export const deleteSubscriptionPlanService = async (subscriptionPlanId) => {
  const url = `/admin/subscription-plans/${subscriptionPlanId}`;

  const response = await apiService.delete(url);
  return response.data;
};

export const changeEmployerSubscriptionService = async (payload) => {
  const url = `/admin/employers/subscriptions/change-plan`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const getCommercialTermsService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/commercial-terms?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const createCommercialTermsService = async (payload) => {
  const url = `/admin/commercial-terms`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const patchCommercialTermsService = async (commercialTermsId, updatedData) => {
  const url = `/admin/commercial-terms/${commercialTermsId}`;
  const response = await apiService.patch(url, updatedData);
  return response.data;
}

export const deleteCommercialTermsService = async (commercialTermsId) => {
  const url = `/admin/commercial-terms/${commercialTermsId}`;

  const response = await apiService.delete(url);
  return response.data;
};

export const changeEmployerCommercialTermsService = async (payload) => {
  const url = `/admin/employers/commercial-terms/change-terms`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const getDashboardSummaryDataService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/summary?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardAppSummaryDataService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/app-summary?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardManagerSummaryDataService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/manager-summary?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardPipelineService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/pipeline?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardPendingDetailsCandidatesService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/pending-details-candidates?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getAccountManagersService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/managers?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardJobApplicationMonthlySummaryService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/job-applications/monthly-summary?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardPipelineMonthlySummaryService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/pipeline/monthly-summary?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardMoMTrendsService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/mom-trends?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getDashboardMonthlyTrendsService = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/admin/dashboard/monthly-trends?${queryString}`;

  const response = await apiService.get(url);
  return response.data;
};

export const getCompanyGoalsService = async () => {
  const url = `/admin/dashboard/goal`;

  const response = await apiService.get(url);
  return response.data;
}

export const setCompanyGoalService = async (payload) => {
  const url = `/admin/dashboard/goal`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const updateCompanyGoalService = async (goalId, payload) => {
  const url = `/admin/dashboard/goal/${goalId}`;
  const response = await apiService.patch(url, payload);
  return response.data;
}

export const getManagerGoalsService = async (managerId) => {
  const url = `/admin/managers/${managerId}/goal`;

  const response = await apiService.get(url);
  return response.data;
}

export const setManagerGoalService = async (managerId, payload) => {
  const url = `/admin/managers/${managerId}/goal`;
  const response = await apiService.post(url, payload);
  return response.data;
}

export const updateManagerGoalService = async (managerId, goalId, payload) => {
  const url = `/admin/managers/${managerId}/goal/${goalId}`;
  const response = await apiService.patch(url, payload);
  return response.data;
}